<app-loading-bar />

<!-- Start::menu -->
@if (isMobile()) {
<app-menu-categoria-mobile />
} @else {
<app-menu-categorias />
}
<!-- End::menu -->

<!-- site -->
<div class="site site_b2c flex">
  <!-- Start::header -->
  <header class="site__header">
    @if (isMobile()) {
    <app-mobile-header />
    } @else {
    <app-header />
    }
  </header>
  <!-- End::header -->

  <!-- Start::content -->
  <div class="site__body">
    <router-outlet />
  </div>
  <!-- End::content -->

  <!-- Start::footer -->
  <footer class="site__footer">
    <app-footer />
  </footer>
  <!-- End::footer -->
</div>
